import React from 'react';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';

/**
 * Prévia do e-mail de um envio, renderizada num iframe isolado (srcDoc).
 * @param {{ open: boolean, loading: boolean, error: string|null, subject: string, html: string, onClose: Function }} props
 */
function EditionPreviewDialog({ open, loading, error, subject, html, onClose }) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle sx={{ pb: 1 }}>
        <Typography variant="caption" color="text.secondary" component="div">Prévia do e-mail</Typography>
        <Typography variant="subtitle1" component="div" sx={{ fontWeight: 600 }}>{subject || 'Novidades da Gabriela'}</Typography>
      </DialogTitle>
      <DialogContent dividers sx={{ p: 0, backgroundColor: '#F1F3F8' }}>
        {loading && (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
            <CircularProgress size={32} />
          </Box>
        )}
        {!loading && error && <Alert severity="error" sx={{ m: 2 }}>{error}</Alert>}
        {!loading && !error && html && (
          <iframe
            title="Prévia do e-mail de novidades"
            srcDoc={html}
            sandbox="allow-popups allow-popups-to-escape-sandbox"
            style={{ width: '100%', height: '70vh', border: 0, display: 'block', backgroundColor: '#FFFFFF', colorScheme: 'light' }}
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Fechar</Button>
      </DialogActions>
    </Dialog>
  );
}

export default EditionPreviewDialog;
